import { PartnerNotificationPath } from "@/common/enum/path";
import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { useNavigate } from "react-router-dom";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  items: NoticeDetailDto[];
}

export const ParnerNoticeSimplePanel: React.FC<Props> = ({ items }) => {
  return (
    <div className="flex flex-col px-[16px] py-[12px] border-[1px] border-semantic-divider rounded-[4px] bg-primary-white w-[708px] h-[230px]">
      {items.map((item, index) => (
        <div key={item.id}>
          <PartnerNoticeSimpleItem item={item} />
          {index < items.length - 1 && (
            <div className="border-b border-semantic-divider" />
          )}
        </div>
      ))}
    </div>
  );
};

interface PartnerNoticeSimpleItemProps {
  item: NoticeDetailDto;
}

const PartnerNoticeSimpleItem: React.FC<PartnerNoticeSimpleItemProps> = ({
  item,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PartnerNotificationPath.NOTICE, {
      state: { id: item.id },
    });
  };

  return (
    <div
      className="flex justify-between items-center py-[8px] cursor-pointer"
      onClick={handleClick}
    >
      <Body14Regular className="text-semantic-text-body truncate max-w-[590px]">
        {item.title}
      </Body14Regular>
      <Body14Regular className="text-semantic-text-tertiary">
        {formatDateToYYYYMMDD(item.createdAt)}
      </Body14Regular>
    </div>
  );
};
